import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Models } from '@ibexfusion/models';
import moment from 'moment';
import { MessengerService } from '@services/messenger/messenger.service';
import { EditMenuDialogComponent } from './edit-menu-dialog/edit-menu-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { IbexCheckboxComponent } from '../../../../../components/ibex-checkbox/ibex-checkbox.component';

@Component({
    selector: 'gastronomy',
    templateUrl: './gastronomy.component.html',
    styleUrls: ['./gastronomy.component.scss'],
    standalone: false
})
export class GastronomyComponent implements OnInit {

  @Input() dynamicContent: Models.DynamicContent;
  @Input() parent: Models.DynamicContentEntrance;
  @Input() create: any;
  @ViewChild('checkboxAll') checkboxAll: IbexCheckboxComponent;
  @ViewChildren(IbexCheckboxComponent) checkboxes!: QueryList<IbexCheckboxComponent>;

  isMain = false;
  showOrderField;

  selectedItemsByField = { lunch: [], dinner: [], hits: [] };
  checkBoxActions = {
    lunch: [{
      translation: 'dynamicContent.disconnectMultipleItems', icon: 'delete', action: () => {
        this.deleteSelected('lunch');
      }
    }],
    dinner: [{
      translation: 'dynamicContent.disconnectMultipleItems', icon: 'delete', action: () => {
        this.deleteSelected('dinner');
      }
    }],
    hits: [{
      translation: 'dynamicContent.disconnectMultipleItems', icon: 'delete', action: () => {
        this.deleteSelected('hits');
      }
    }]
  }

  constructor(private messengerService: MessengerService, private dialog: MatDialog) {
  }

  ngOnInit() {
    this.isMain = this.parent instanceof Models.DynamicContentEntrance;
    this.messengerService.$activeRoles.subscribe((roles: any[]) => {
      for (const role of roles) {
        if (role.roleName === 'orderModuleAdmin') {
          this.showOrderField = true;
        }
      }
    });
  }

  change(event, field, isContent = false) {
    if (isContent) {
      this.dynamicContent.content[field] = event;
    } else {
      this.dynamicContent[field] = event;
    }
  }

  async addMenu(field) {
    const menu: any = await this.dialog.open(EditMenuDialogComponent, {
      width: '600px', height: '600px', data: { showOrderField: this.showOrderField }
    }).afterClosed().toPromise();
    if (menu?.menu) {
      this.dynamicContent.content[field].push(menu.menu);
    }
  }

  async editMenu(field, index) {
    const menu: any = await this.dialog.open(EditMenuDialogComponent, {
      width: '600px', height: 'auto', data: { menu: JSON.parse(JSON.stringify(this.dynamicContent.content[field][index])), showOrderField: this.showOrderField }
    }).afterClosed().toPromise();
    if (menu?.menu) {
      this.dynamicContent.content[field][index] = menu.menu;
    }
  }

  removeMenu(field, index) {
    this.dynamicContent.content[field].splice(index, 1);
  }

  checkDate(event: any) {
    if (/\d\d?\.\d\d?\.\d\d\d?\d?/.test(event.target.value)) {
      this.dynamicContent.content.date = moment(event.target.value, 'DD.MM.YYYY').format('YYYY-MM-DD') + 'T00:00:00.000Z';
    } else {
      this.dynamicContent.content.date = moment(event.target.value).format('YYYY-MM-DD') + 'T00:00:00.000Z';
    }
  }

  selectItemsAll(key) {
    this.selectedItemsByField[key] = [];
    if (this.selectedItemsByField[key]?.length !== this.dynamicContent?.content[key]?.length) {
      this.selectedItemsByField[key] = [];
      for (const el of this.dynamicContent?.content[key]) {
        this.selectedItemsByField[key].push(el);
      }
    }
    this.checkboxes.filter(el => el.id !== 'checkboxAll' && !!el.elementRef.nativeElement.classList.contains(key)).forEach(checkbox => {
      if (this.selectedItemsByField[key]?.length === 0) {
        checkbox.unselect();
      } else {
        checkbox.select();
      }
    });
  }

  selectItem(item, key) {
    if (this.selectedItemsByField[key].includes(item)) {
      this.selectedItemsByField[key].splice(this.selectedItemsByField[key].indexOf(item), 1);
    } else {
      this.selectedItemsByField[key].push(item);
    }
    if (this.selectedItemsByField[key]?.length === this.dynamicContent?.content[key]?.length) {
      this.checkboxAll.select();
    } else {
      this.checkboxAll.unselect();
    }
  }

  deleteSelected(key) {
    for (const el of this.selectedItemsByField[key]) {
      this.dynamicContent?.content[key].splice(this.dynamicContent?.content[key].indexOf(el), 1);
    }
    this.selectedItemsByField[key] = [];
  }

  dropItem(event: any, key) {
    if (event.previousIndex !== event.currentIndex) {
      const item = this.dynamicContent.content[key].splice(event.previousIndex, 1)[0];
      this.dynamicContent.content[key].splice(event.currentIndex, 0, item);
    }
  }
}
